module.exports = __webpack_public_path__ + "media/bowls/bowl-with-food-ab604251.svg";